/**
 * @fileOverview
 * 订阅Props变更修饰器
 * @author iNahoo
 * @since 2018/6/14.
 */

import { Record } from 'immutable';

/**
 * 计算请求是否完成
 * @param oldValue
 * @param newValue
 */
export const isRequestEnd = (oldValue, newValue) => oldValue.isFetching && !newValue.isFetching;

/**
 * 判断对象是否来自 Saga - Redux 数据流
 * @param obj
 */
const isSagaRequest = obj => typeof obj === 'object'
  && obj
  && 'error' in obj
  && 'isFetching' in obj
  && obj.payload instanceof Record
  && obj.response instanceof Record;


/**
 * 订阅 Component 的 Props 变更
 * @param target
 */
export function subscribeProps(target) {
  // 私有Key名 - 可以考虑Symbol支持
  const __subscibeFns__ = '__subscibeFns__';
  const __subscibeKeys__ = '__subscibeKeys__';
  const __checkSubscibeKeys__ = '__checkSubscibeKeys__';

  return class extends target {
    constructor(props) {
      super(props);

      if (!this.subscribeProps) this.subscribeProps = {};

      // 生成 keys 数组
      Object.defineProperty(this, __subscibeKeys__, {
        value: Object.keys(this.subscribeProps),
      });

      // 生成 回调Map (绑定上下文)
      const fnmap = {};
      this[__subscibeKeys__].forEach((key) => {
        fnmap[key] = this.subscribeProps[key].bind(this);
      });
      Object.defineProperty(this, __subscibeFns__, {
        value: fnmap,
      });

      // 生成 比较函数Map
      Object.defineProperty(this, __checkSubscibeKeys__, {
        value(prevProps, newProps) {
          this[__subscibeKeys__].forEach((key) => {
            const ov = prevProps[key];
            const nv = newProps[key];

            if (isSagaRequest(nv)) {
              /**
               * Redux & Sage 体系返回处理
               * -----------------------------
               * 每当请求完毕必然调用回调
               * - 如果需要省去对一致数据的处理，自行在回调中以 compareData 判断
               */
              (!ov || isRequestEnd(ov, nv)) && this[__subscibeFns__][key](nv, ov, prevProps);
            // ==============================
            } else if (ov !== nv) {
              // 其他值
              this[__subscibeFns__][key](nv, ov, prevProps);
            }
          });
        },
      });
    }

    componentDidMount() {
      super.componentDidMount && super.componentDidMount();
      this[__checkSubscibeKeys__]({}, this.props);
    }

    componentDidUpdate(prevProps) {
      super.componentDidUpdate && super.componentDidUpdate(prevProps);
      this[__checkSubscibeKeys__](prevProps, this.props);
    }
  };
}



// WEBPACK FOOTER //
// ./src/utils/decorators/subscribeProps.js